

import React from 'react';
import { ProfileView } from '../components/ProfileUser/ProfileView';

export const PerfilPage = () => {
  return <ProfileView />;
};
